import React from 'react';
import { Row, Col, Form, Input, Select, Checkbox, Modal, InputNumber } from 'antd';

import UilCamera from '@iconscout/react-unicons/icons/uil-camera';
import UilTrashAlt from '@iconscout/react-unicons/icons/uil-trash-alt';

import { Main, BasicFormWrapper } from '../../styled.js';
import { Button } from '../../../components/buttons/buttons.js';
import { Cards } from '../../../components/cards/frame/cards-frame.js';
import { AddUser } from '../style.js';
import Heading from '../../../components/heading/heading.js';
import Spinner from '../../common/Spinner.js';
import QuillEditor from '../../common/QuillEditor.js';
import Functions from '../../../utility/functions.js';
import CancelImg from '../../../static/img/Search-cancel.svg';

/**
 * ConfigEdit — editable form for host listing configuration.
 * All state and handlers come from useHostListingConfig via ConfigAddEdit.
 */
const ConfigEdit = ({
  // Form instance
  form,

  // Refs
  quillEditorRef,
  welcomVideoModal,
  // Layout
  screens,
  cardsBodyPadding,
  initialCardBodyPadding,
  isMobileView,
  splitPanelHeight,

  // Constants
  maxCharCount,
  hoursArray,
  daysBeforerules,
  isBlank,

  // Spinner
  spinnerLoader,
  loading,

  // Image
  previewImage,
  showImageValidation,
  listing_image,

  // Time arrays
  unlockCheckInContentArray,
  unlockCheckInDoorCodeArray,
  lockCheckOutContentArray,
  lockCheckOutDoorCodeArray,
  displayArrivalCheckoutStatus,
  maxDoorDays,
  doorcodeStatus,

  // House rules
  house_rules,
  isRequiredHouseRule,
  maxLengthHouseRules,

  // Rich text
  previewHouseManual,
  previewCheckoutInstructions,
  isModalVisible,

  // Locals map
  addListingMap,
  isMapDescriptionRequired,
  isMapURLRequired,
  isMapImageRequired,
  isMapTitleRequired,

  // CMS
  previewCmsContent,
  openthemeCms,
  staticHelptext,
  // Form toggles
  useDefaultCheckTime,
  useIndividualRecommendation,
  useGlobalHouseManual,
  useGlobalCheckoutInstructions,
  selectedForm,
  userFormsDropList,
  configuration,
  themeInfoModal,
  // Theme
  listingThemeDropdownList,
  selectedThemeSlug,
  state,

  // Setters
  setIsModalVisible,
  setOpenthemeCms,
  setUseDefaultCheckTime,
  setUseIndividualRecommendation,
  setSelectedForm,
  setState,
  editorHouseManualRef,
  editorCheckoutInstructionRef,

  // Handlers
  handleImageChange,
  deletePreviewImage,
  handleSelectCheckInTime,
  handleSelectCheckOutTime,
  changeDisplayArrivalCheckoutInstructions,
  handleInputChange,
  handleLinkClick,
  handleContentDaysChange,
  handleSelectContentCheckInTime,
  handleSelectContentCheckOutTime,
  handleDoorCodeStatus,
  addHouseRule,
  deleteHouseRule,
  houseRulesChange,
  handleLocalsImageChanges,
  listingMapChange,
  handleAddMapRow,
  handleDeleteMapRow,
  handleArrivalInstructionsValue,
  handlehouseManualValue,
  handleRentalInstructionsValue,
  handleCheckoutInstructionsValue,
  insertVariable,
  handleHostConfigSubmit,
  checkValidation,
  handleCancel,
  handleSelectTheme,
  handleChangeFormsOptions,
  handleGlobalCheckoutChange,
  handleGlobalHouseManual,
  handleOpenModal,
  handleLocalMapCheckBox,
  earlyCheckinPopupInfo,
  earlyCheckInActivePopup,
  showEarlyCheckingInfo,
  closeEarlyCheckInPopupInfo,
  jotformActivePopup,
  setJotformActivePopup,

}) => {
  return (
    <>
      <Spinner loader={spinnerLoader} />
      {/* <Cards xs={24} headless className="borderRadius common_fiter_table"> */}
      <Main className="mainBlock pl-0 pr-0">
        <AddUser >
          <BasicFormWrapper>
            <div
              className="listing-split-layout"
              style={!isMobileView && splitPanelHeight ? { height: `${splitPanelHeight}px` } : undefined}
            >
              <div className="listing-split-main">
                <Form
                  form={form}
                  name="listingForm"
                  onFinish={handleHostConfigSubmit}
                  onValuesChange={handleInputChange}
                >
                  <AddUser>
                    <BasicFormWrapper>
                      <Cards headless bodypadding={initialCardBodyPadding} className="mb-25 borderRadius common_fiter_table">

                        {/* ── CONNECTION SETTINGS HEADER ───────────── */}
                        <div className="info mb-38">
                          <Heading as="h3" className="mb-0 line_height_20">
                            <span>CONNECTION SETTINGS</span>
                          </Heading>
                        </div>

                        {/* ── LISTING IMAGE ─────────────────────────── */}
                        <Row gutter={15}>
                          {/* 🔹 Row 1: Label (12 cols) */}
                          <Col xs={24} md={24}>
                            <div className="info upload-section-listing-image">
                              <Heading as="h4" className="line_height_20 mb-7">
                                <span className='listing_image_label '> Listing Image</span>
                              </Heading>
                              <div
                                className="guest-ready-text listing_all_help_text img_info_text"
                                dangerouslySetInnerHTML={{
                                  __html: staticHelptext?.listing_image_guideline,
                                }}
                              />
                            </div>
                          </Col>

                          {/* 🔹 Force new row */}
                          <Col xs={24}>
                            <Row gutter={15}>
                              {/* 🔹 Row 2: Image (8 cols) */}
                              <Col xs={24} md={8}>
                                <div className="image_upload_box mt-0 mb-0">
                                  <div className="upload-section">
                                    <figure className="photo-upload align-start-v">
                                      <figcaption>
                                        <img
                                          className={previewImage ? 'image_uploaded' : ''}
                                          src={previewImage || require('../../../static/img/avatar/building.png')}
                                          alt="Preview"
                                        />
                                        <label htmlFor="fileInputs" className="btn-upload">
                                          <div className="ant-upload-select">
                                            <span className="btn-upload">
                                              <UilCamera />
                                            </span>
                                          </div>
                                          <input
                                            type="file"
                                            id="fileInputs"
                                            accept="image/*"
                                            className="upload_img_input"
                                            onChange={handleImageChange}
                                            onClick={(e) => { e.currentTarget.value = null; }}
                                          />
                                        </label>
                                      </figcaption>
                                    </figure>
                                    {listing_image && (
                                      <span onClick={() => deletePreviewImage('')} className="status error">
                                        <img src={CancelImg} alt="Remove" />
                                      </span>
                                    )}
                                  </div>
                                </div>
                                {showImageValidation && (
                                  <div className="showImageError">
                                    <div className="ant-form-item-has-error ant-form-item-explain-error">
                                      Please select listing image
                                    </div>
                                  </div>
                                )}
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Cards>

                      <Cards headless bodypadding={cardsBodyPadding} className="mt-25 borderRadius2">
                        <Row gutter={[19, 0]} className="addnewbtn">
                          {/* ── GUEST REGISTRATION — HOUSE RULES ───── */}
                          <Col xs={24} md={24}>
                            <div className="info mb-10 inner_preview_btn">
                              <Heading as="h3">GUEST REGISTRATION</Heading>
                            </div>

                            <Row gutter={24} className="mb-38 addnewbtn">
                          <Col span={24} className="mt-19">
                            <div className="text-padding">
                              <div className="detail_image_info">
                                <p className="listing_all_label_text mb-19">House Rules</p>
                              </div>
                              <div
                                className="listing_all_help_text"
                                dangerouslySetInnerHTML={{
                                  __html: staticHelptext?.house_rules_guideline,
                                }}
                              />
                            </div>
                          </Col>
                              <Col xs={21} md={24}>
                                {/* <div className="detail_image_info">
                                  <span className="listing_all_label_text">House Rules</span>
                                </div>
                                <Col xs={24} md={24} className='pl-0 pr-0'>
                                  <div className="listing_all_help_text" dangerouslySetInnerHTML={{ __html: staticHelptext?.house_rules_guideline }} />
                                </Col> */}
                                {house_rules.map((value, index) => (
                                  <Row
                                    key={value.id || index}
                                    gutter={[19, 0]}
                                    className="house_rule_item house-rule-row"
                                  >
                                    <Col xs={24} md={18}>
                                      <Form.Item
                                        label={
                                          <span>
                                            House Rule #{index + 1}
                                          </span>
                                        }
                                        onChange={(e) => houseRulesChange(e, index)}
                                        initialValue={value.label}
                                        className="listing_field_name mb-0"
                                      >
                                        <Input
                                          placeholder="Enter house rule"
                                          value={value.label}
                                          id={`house_rule_${index}`}
                                          className="h-50"
                                        />
                                      </Form.Item>
                                      {isRequiredHouseRule && isBlank(value.label) && (
                                        <div className="showImageError">
                                          <div className="ant-form-item-has-error ant-form-item-explain-error">
                                            Please add house rule
                                          </div>
                                        </div>
                                      )}
                                      {maxLengthHouseRules?.includes(index) && (
                                        <div className="showImageError">
                                          <div className="ant-form-item-has-error ant-form-item-explain-error">
                                            {`The maximum limit is ${maxCharCount} characters`}
                                          </div>
                                        </div>
                                      )}
                                    </Col>
                                    <Col
                                      xs={24}
                                      md={6}
                                      className="btn-align delete_icon_btn top_28 mt-10 house-rule-delete-col"
                                    >
                                      {house_rules.length > 0 && (
                                        <Button
                                          size="default"
                                          outlined
                                          type="error"
                                          onClick={() => deleteHouseRule(index)}
                                        >
                                          <UilTrashAlt />
                                        </Button>
                                      )}
                                    </Col>
                                  </Row>
                                ))}

                                <Row gutter={15} className="mt-19">
                                  <Col xs={12}>
                                    <Button
                                      size="default"
                                      outlined
                                      type="primary"
                                      key="submit"
                                      onClick={addHouseRule}
                                    >
                                      + Add House Rule
                                    </Button>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Col>

                        </Row>

                        {/* ── SHORT TERM RENTAL AGREEMENT ────────────── */}
                        <Row gutter={15} >
                          <Col xs={24}>
                          <div className="">
                            <Form.Item
                              label={<span className='mb-0'>Short Term Rental Agreement</span>}
                              className="listing_field_name mb-0"
                              name="rental_instructions"
                            >
                            <>
                              <div className="listing_all_help_text" dangerouslySetInnerHTML={{ __html: staticHelptext?.agreement_template }} />
                              <QuillEditor
                                placeholder="Enter short term rental agreement"
                                setValue={handleRentalInstructionsValue}
                                editorValue={form.getFieldValue('rental_instructions')}
                                handleInputChange={handleInputChange}
                              />
                            </>
                            </Form.Item>
                          </div>
                          </Col>

                          {/* ── SECONDARY FORM ─────────────────────── */}
                          <>
                           <Col xs={24} md={12} className="pt-38">
  <Form.Item
    label={
      <span>
        Secondary Form (🛎️
        <a
          className="common_urlLink"
          onClick={(event) => {
            showEarlyCheckingInfo(31);
            handleLinkClick(event);
          }}
        >
          Help please!
        </a>
        )
      </span>
    }
    className="custom_input_style listing_field_name mb-0"
    name="unlock_door_code_before_checkin"
  >
    {/* Help text */}
    <div className="text-padding">
      <div
        className="listing_all_help_text"
        dangerouslySetInnerHTML={{
          __html: staticHelptext?.secondary_form,
        }}
      />
    </div>

    {/* Select + Delete aligned */}
    <div className="select-with-action">
      <Select
        size="large"
        className="ninjadash-fullwidth-select"
        placeholder="No Secondary Form"
        showSearch
        allowClear
        onChange={handleChangeFormsOptions}
        value={selectedForm}
      >
        {userFormsDropList.map((item) => (
          <Select.Option key={item.slug} value={item.slug}>
            {item.title}
          </Select.Option>
        ))}
      </Select>

      {selectedForm && (
        <Button
          size="large"
          type="error"
          className="delete-btn"
          onClick={() => setSelectedForm(null)}
        >
          <UilTrashAlt />
        </Button>
      )}
    </div>
  </Form.Item>
</Col>
                          </>
                        </Row>

                      </Cards>
                      <Cards headless bodypadding={cardsBodyPadding} className="mb-25 mt-25 borderRadius2">
                        <Row gutter={[19, 0]} className="addnewbtn">
                          <Col xs={24} md={24}>
                            <div className="info inner_preview_btn line_height_20 mb-38">
                              <Heading as="h3" className="mb-0">ARRIVAL GUIDE</Heading>
                            </div>
                          </Col>
                          {/* ── THEME ──────────────────────────────── */}
                          <Col xs={24} md={12}>
                            <div className="mb-38">
                              <Form.Item
                                label={<span className="guest-ready-text">Theme (🛎️ <a
                                  className="common_urlLink"
                                  onClick={(e) => showEarlyCheckingInfo(27)}
                                >
                                  Help please!
                                </a>
                                  )</span>
                                }
                                name="theme_slug"
                                className="custom_input_style listing_field_name"
                              >
                                <Select
                                  size="large"
                                  className="ninjadash-fullwidth-select"
                                  placeholder="Theme"
                                  onChange={handleSelectTheme}
                                  value={selectedThemeSlug || null}
                                  allowClear
                                >
                                  {listingThemeDropdownList.map((item) => (
                                    <Select.Option key={item.slug} value={item.slug}>
                                      {item.theme_title}
                                    </Select.Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </div>
                          </Col>

                          {/* ── WELCOME VIDEO ──────────────────────── */}
                          <Col xs={24} md={12}>
                            <div className="mb-38">
                              <Form.Item
                                label={
                                  <span className="guest-ready-text">
                                    Welcome Video (🛎️ <a
                                      className="common_urlLink"
                                      onClick={(e) => showEarlyCheckingInfo(32)}
                                    >
                                      Help please!
                                    </a>
                                    )
                                  </span>
                                }
                                name="video"
                                className="listing_field_name"
                              >
                                <Input
                                  placeholder="Enter youtube embed code"
                                  tabIndex="9"
                                  className="wifi h-50"
                                />
                              </Form.Item>
                            </div>
                          </Col>

                          {/* ── DEFAULT CHECK-IN / CHECK-OUT TIME ──── */}
                          <Col xs={24} md={24} className="addnewbtn mb-38">
                            <Row gutter={15}>
                              <Col xs={24} md={24}>
                              <div className="detail_image_info">
                                <p className="listing_all_label_text mb-19">Check-In & Out Times</p>
                              </div>
                                <div
                                  className="listing_all_help_text"
                                  dangerouslySetInnerHTML={{
                                    __html: staticHelptext?.checkin_checkout_times,
                                  }}
                                />
                              </Col>

                              <Col xs={24} md={24} >
                                <Row gutter={[19, 0]}>
                                  <Col xs={24} md={12}>
                                    <Form.Item
                                      label="Check In Time"
                                      name="checkin_time"
                                      className="custom_input_style listing_field_name"
                                    >
                                      <Select
                                        size="large"
                                        className="ninjadash-fullwidth-select"
                                        placeholder="Select time"
                                        allowClear
                                        onChange={handleSelectCheckInTime}
                                      >
                                        {hoursArray.map((value) => (
                                          <Select.Option key={value} value={value}>
                                            {value}
                                          </Select.Option>
                                        ))}
                                      </Select>
                                    </Form.Item>
                                  </Col>

                                  <Col xs={24} md={12}>
                                    <Form.Item
                                      label="Check Out Time"
                                      name="checkout_time"
                                      className="custom_input_style listing_field_name"
                                    >
                                      <Select
                                        size="large"
                                        className="ninjadash-fullwidth-select"
                                        placeholder="Select time"
                                        allowClear
                                        onChange={handleSelectCheckOutTime}
                                      >
                                        {hoursArray.map((value) => (
                                          <Select.Option key={value} value={value}>
                                            {value}
                                          </Select.Option>
                                        ))}
                                      </Select>
                                    </Form.Item>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Col>

                          {/* ── WIFI NAME ──────────────────────────── */}
                          <Col span={24} className="">
                            <div className="text-padding">
                              <div className="detail_image_info">
                                <p className="listing_all_label_text mb-19">Wifi Info</p>
                              </div>
                              <div
                                className="listing_all_help_text"
                                dangerouslySetInnerHTML={{
                                  __html: staticHelptext?.wifi_info,
                                }}
                              />
                            </div>
                          </Col>
                          {/* <Col xs={24} md={24}>
                              <div className="detail_image_info">
                                <span className="listing_all_label_text">Wifi Info</span>
                              </div>
                            <div
                              className="listing_all_help_text"
                              dangerouslySetInnerHTML={{
                                __html: staticHelptext?.wifi_info,
                              }}
                            />
                          </Col> */}
                          <Col xs={24} md={12}>
                            <div className="mb-38">
                              <Form.Item
                                label="Wifi Name"
                                name="wifi_name"
                                className="listing_field_name"
                              >
                                <Input placeholder="Enter wifi name" tabIndex="7" className="h-50" />
                              </Form.Item>
                            </div>
                          </Col>

                          {/* ── WIFI PASSWORD ──────────────────────── */}
                          <Col xs={24} md={12}>
                            <div className="mb-38">
                              <Form.Item
                                label="Wifi Password"
                                name="wifi_password"
                                className="listing_field_name"
                              >
                                <Input
                                  placeholder="Enter wifi password"
                                  tabIndex="8"
                                  className="wifi h-50"
                                />
                              </Form.Item>
                            </div>
                          </Col>
                        </Row>
                        <Row gutter={[19, 0]} className="addnewbtn mb-38">

                          {/* ── CHECK-IN INSTRUCTIONS VISIBILITY ─────── */}
                          <Col xs={24} md={24}>
                            <Row gutter={15}>
                              <Col xs={24} md={24}>
                                <div className="info">
                                  <Heading as="h3" className='mb-0'>
                                    <span>CHECK-IN INSTRUCTIONS VISIBILITY SETTINGS</span>
                                  </Heading>
                                </div>
                              </Col>

                              <Col xs={24} md={24} className={displayArrivalCheckoutStatus ? 'pb-38' : ''}>
                                <div className="pt-38">
                                  <Form.Item
                                    className="checkbox-title-inline h-20 listing-long-checkbox"
                                    label={
                                      <span className="guest-ready-text">
                                        <span onClick={handleLinkClick}>
                                          Begin displaying Arrival Instructions and Door Code directly after guests complete their registration (uncheck for earlier display settings)
                                        </span>
                                      </span>
                                    }
                                    name="is_display_arrival_and_checkout_instruction"
                                    labelCol={{ className: 'custom-checkbox-label' }}
                                  >
                                    <Checkbox
                                      className="cus-checkbox-inline"
                                      onChange={changeDisplayArrivalCheckoutInstructions}
                                      checked={displayArrivalCheckoutStatus}
                                    />
                                  </Form.Item>
                                </div>
                              </Col>

                              {!displayArrivalCheckoutStatus && (
                                <Col xs={24} md={24} className="mb-38 pt-19">
                                  <Row gutter={[19, 0]} className="arrival-checkout-row">
                                    <Col span={24} className="mb-19">
                                      <div className="text-padding">
                                        <Form.Item
                                          label={
                                            <span>Begin displaying my arrival and check-out instructions:</span>
                                          }
                                          name="unlock_content_before_checkin"
                                          className="custom_input_style"
                                        />
                                      </div>
                                    </Col>

                                    <Col xs={24} md={6}>
                                      <Form.Item
                                        label={<span>Days before check-in day</span>}
                                        name="unlock_content_before_checkin_days"
                                        className="early_check_input listing_field_name arrival-equal-label"
                                        rules={daysBeforerules}
                                      >
                                        <InputNumber
                                          prefix={''}
                                          placeholder="Enter days before"
                                          defaultValue={0}
                                          max={31}
                                          min={0}
                                          onChange={handleContentDaysChange}
                                          tabIndex="2"
                                        />
                                      </Form.Item>
                                    </Col>

                                    <Col xs={24} md={6}>
                                      <Form.Item
                                        label={<span>At (local time)</span>}
                                        name="unlock_content_before_checkin"
                                        className="custom_input_style listing_field_name arrival-equal-label"
                                      >
                                        <Select
                                          size="large"
                                          className="ninjadash-fullwidth-select"
                                          placeholder="Select time"
                                          onChange={handleSelectContentCheckInTime}
                                          allowClear
                                        >
                                          {unlockCheckInContentArray.map((value) => (
                                            <Select.Option key={value} value={value}>
                                              {value}
                                            </Select.Option>
                                          ))}
                                        </Select>
                                      </Form.Item>
                                    </Col>

                                    <Col xs={24} md={6}>
                                      <Form.Item
                                        label={<span>And then hide it on check-out day at (local time)</span>}
                                        name="lock_content_after_checkout"
                                        className="custom_input_style listing_field_name arrival-equal-label"
                                      >
                                        <Select
                                          size="large"
                                          className="ninjadash-fullwidth-select"
                                          placeholder="Select time"
                                          onChange={handleSelectContentCheckOutTime}
                                          allowClear
                                        >
                                          {lockCheckOutContentArray.map((value) => (
                                            <Select.Option key={value} value={value}>
                                              {value}
                                            </Select.Option>
                                          ))}
                                        </Select>
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                </Col>
                              )}
                            </Row>
                          </Col>

                          {/* ── DOOR CODE SETTINGS ─────────────────── */}
                          <Col xs={24} md={24}>
                            <Row gutter={15}>
                              <Col xs={24} md={24}>
                                <div className={doorcodeStatus ? 'cus-label-wrap' : 'cus-label-wrap'}>
                                  <Form.Item
                                    className="checkbox-title-inline listing-long-checkbox"
                                    label={
                                      <span>
                                        Even when my Arrival Instructions are visible, I want to hide the Door Code until time of check-in (uncheck for earlier display settings){" "}(🛎️
                                        <a
                                          className="common_urlLink"
                                          onClick={(event) => {
                                            showEarlyCheckingInfo(33);
                                            handleLinkClick(event);
                                          }}
                                        >
                                          Help please!
                                        </a>
                                        )
                                      </span>
                                    }
                                    name="is_doorcode_visible"
                                    labelCol={{ className: 'custom-checkbox-label' }}
                                  >
                                    <Checkbox
                                      className="cus-checkbox-inline"
                                      onChange={handleDoorCodeStatus}
                                      checked={doorcodeStatus}
                                    />
                                  </Form.Item>
                                </div>
                              </Col>

                              {!doorcodeStatus && (
                                <Col xs={24} md={24} className="pt-19">
                                  <Row gutter={[19, 0]} className="arrival-checkout-row ">
                                    <Col span={24} className="mb-19">
                                      <div className="text-padding">
                                        <Form.Item
                                          label={<span>Begin displaying my Door Code:</span>}
                                          name="unlock_door_code_before_checkin"
                                          className="custom_input_style"
                                        />
                                      </div>
                                    </Col>

                                    <Col xs={24} md={6}>
                                      <Form.Item
                                        label={<span>Days before check-in day</span>}
                                        name="unlock_door_code_before_checkin_days"
                                        className="early_check_input listing_field_name arrival-equal-label"
                                        rules={daysBeforerules}
                                      >
                                        <InputNumber
                                          prefix={''}
                                          placeholder="Enter days before"
                                          defaultValue={0}
                                          max={maxDoorDays}
                                          min={0}
                                          tabIndex="2"
                                        />
                                      </Form.Item>
                                    </Col>

                                    <Col xs={24} md={6}>
                                      <Form.Item
                                        label={<span>At (local time)</span>}
                                        name="unlock_door_code_before_checkin"
                                        className="custom_input_style listing_field_name arrival-equal-label"
                                      >
                                        <Select
                                          size="large"
                                          className="ninjadash-fullwidth-select"
                                          placeholder="Select time"
                                          allowClear
                                        >
                                          {unlockCheckInDoorCodeArray.map((value) => (
                                            <Select.Option key={value} value={value}>
                                              {value}
                                            </Select.Option>
                                          ))}
                                        </Select>
                                      </Form.Item>
                                    </Col>

                                    <Col xs={24} md={6}>
                                      <Form.Item
                                        label={<span>And then hide it on check-out day at (local time)</span>}
                                        name="lock_door_code_after_checkout"
                                        className="custom_input_style listing_field_name arrival-equal-label"
                                      >
                                        <Select
                                          size="large"
                                          className="ninjadash-fullwidth-select"
                                          placeholder="Select time"
                                          allowClear
                                        >
                                          {lockCheckOutDoorCodeArray.map((value) => (
                                            <Select.Option key={value} value={value}>
                                              {value}
                                            </Select.Option>
                                          ))}
                                        </Select>
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                </Col>
                              )}
                            </Row>
                          </Col>
                        </Row>

                        {/* ── ARRIVAL INSTRUCTIONS ───────────────────── */}
                        <Row gutter={15} className="mb-38">
                          <Col xs={24}>
                            <div className="provider_bodyvariable_box">
                              <Form.Item
                                label={
                                  <div className="arrival-header provider_body_veriable">
                                    <div className="inner_preview_btn">
                                      <Heading as="h3" className="mb-0 line_height_20 pr-10">
                                        ARRIVAL INSTRUCTIONS
                                      </Heading>
                                    </div>
                                  </div>
                                }
                                name="arrival_instructions"
                                className="listing_field_name arrival-instruction-editor"
                              >
                                <QuillEditor
                                  placeholder="Enter arrival instructions"
                                  setValue={handleArrivalInstructionsValue}
                                  editorValue={form.getFieldValue('arrival_instructions')}
                                  handleInputChange={handleInputChange}
                                  showDoorCodeButton
                                  onDoorCodeClick={insertVariable}
                                  ref={quillEditorRef}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                        </Row>

                        <Row gutter={24} className="addnewbtn listing-local-guide-block">
                          <Col xs={24} md={24}>
                            <div className="info mb-38">
                              <Heading as="h3" className="line_height_20">
                                <span>LOCAL GUIDES AND LINKS</span>
                              </Heading>
                            </div>
                          </Col>

                          <Col xs={24} md={24}>
                            <div >
                              <Form.Item
                                className="checkbox-title-inline listing-long-checkbox"
                                label={
                                  <span className="guest-ready-text">
                                    I want individual recommendations per listing (uncheck if you want to use one set of recommendations for all listings)
                                  </span>
                                }
                                name="use_individual_recommendation"
                                labelCol={{ className: 'custom-checkbox-label' }}
                              >
                                <Checkbox
                                  className="cus-checkbox-inline"
                                  checked={useIndividualRecommendation}
                                  onChange={(e) => handleLocalMapCheckBox(e.target.checked)}
                                />
                              </Form.Item>
                            </div>
                          </Col>

                          {!useIndividualRecommendation && (
                            <Col xs={24} className='pb-19 pt-19'>
                              {addListingMap.map((value, index) => (
                                <div key={index} className="house_rule_item listing-local-guide-item">
                                  <div className="guide-row">

                                    {/* Image */}
                                    <div className="guide-col guide-image">
                                      <div>
                                        <Form.Item
                                          label={<span>Image</span>}
                                          className="listing_field_name"
                                        >
                                          <div className="map_image_sec">
                                            <figure className="photo-upload align-start-v">
                                              <figcaption>
                                                <img
                                                  className={value.full_image_path ? 'image_uploaded' : ''}
                                                  src={
                                                    value?.full_image_path ||
                                                    require('../../../static/img/image-placeholder.png')
                                                  }
                                                  alt="Preview"
                                                />
                                                <label
                                                  htmlFor={`fileInput-${index}`}
                                                  className="btn-upload"
                                                >
                                                  <div className="ant-upload-select">
                                                    <span className="btn-upload">+</span>
                                                  </div>
                                                  <input
                                                    type="file"
                                                    id={`fileInput-${index}`}
                                                    accept="image/*"
                                                    className="upload_img_input"
                                                    onChange={(e) => handleLocalsImageChanges(e, index)}
                                                    onClick={(e) => { e.currentTarget.value = null; }}
                                                  />
                                                </label>
                                              </figcaption>
                                            </figure>
                                          </div>
                                        </Form.Item>
                                      </div>
                                      {isMapImageRequired && isBlank(value.image) && (
                                        <div className="showImageError">
                                          <div className="ant-form-item-has-error ant-form-item-explain-error">
                                            Please select image
                                          </div>
                                        </div>
                                      )}
                                    </div>

                                    {/* Guide Title */}
                                    <div className="guide-col guide-title">
                                      <div>
                                        <Form.Item
                                          label={<span>Guide Title</span>}
                                          className="listing_field_name"
                                        >
                                          <Input
                                            placeholder="Enter guide title"
                                            value={value.title}
                                            maxLength={255}
                                            onChange={(e) => listingMapChange(e, index, 1)}
                                            className="h-50"
                                          />
                                        </Form.Item>
                                      </div>
                                      {isMapTitleRequired && isBlank(value.title) && (
                                        <div className="showImageError">
                                          <div className="ant-form-item-has-error ant-form-item-explain-error">
                                            Please enter guide title
                                          </div>
                                        </div>
                                      )}
                                    </div>

                                    {/* Description */}
                                    <div className="guide-col guide-description">
                                      <div>
                                        <Form.Item
                                          label={<span>Description</span>}
                                          className="listing_field_name"
                                        >
                                          <Input
                                            placeholder="Enter description"
                                            value={value.description}
                                            onChange={(e) => listingMapChange(e, index, 2)}
                                            className="h-50"
                                          />
                                        </Form.Item>
                                      </div>
                                      {isMapDescriptionRequired && isBlank(value.description) && (
                                        <div className="showImageError">
                                          <div className="ant-form-item-has-error ant-form-item-explain-error">
                                            Please enter description
                                          </div>
                                        </div>
                                      )}
                                    </div>

                                    {/* Guide URL */}
                                    <div className="guide-col guide-url">
                                      <div>
                                        <Form.Item
                                          label={<span>Guide URL</span>}
                                          className="listing_field_name"
                                        >
                                          <Input
                                            placeholder="Enter guide URL"
                                            value={value.redirect_url}
                                            maxLength={255}
                                            onChange={(e) => listingMapChange(e, index, 3)}
                                            className="h-50"
                                          />
                                        </Form.Item>
                                      </div>
                                      {isMapURLRequired && isBlank(value.redirect_url) && (
                                        <div className="showImageError">
                                          <div className="ant-form-item-has-error ant-form-item-explain-error">
                                            Please enter guide URL
                                          </div>
                                        </div>
                                      )}
                                    </div>

                                    {/* Delete */}
                                    <div className="guide-col guide-delete btn-align top_28 delete_icon_btn mt-10">
                                      {addListingMap.length > 1 && (
                                        <Button
                                          size="default"
                                          outlined
                                          type="error"
                                          onClick={() => handleDeleteMapRow(index)}
                                        >
                                          <UilTrashAlt />
                                        </Button>
                                      )}
                                    </div>

                                  </div>
                                </div>
                              ))}

                              <Row gutter={15} className="mt-19 listing-local-guide-actions">
                                <Col xs={6} sm={12}>
                                  <Button
                                    size="default"
                                    outlined
                                    type="primary"
                                    onClick={handleAddMapRow}
                                  >
                                    + Add Guide
                                  </Button>
                                </Col>
                              </Row>
                            </Col>
                          )}
                        </Row>

                        {/* ── HOUSE MANUAL ───────────────────────────── */}
                        <Row gutter={15} className='mt-38 mb-38'>
                          <Col xs={24}>
                            {/* Title - Always Visible */}
                            <div className="arrival-header inner_preview_btn">
                              <Heading as="h3" className="mb-19 line_height_20 pr-10">
                                HOUSE MANUAL
                              </Heading>
                            </div>
                          </Col>

                          <Col xs={24} className=''>
                            {/* Checkbox */}
                            <Form.Item
                              className="checkbox-title-inline listing-long-checkbox pb-19"
                              label={
                                <span className="guest-ready-text">
                                  I have individual house manuals per listing (uncheck if you want to use
                                  one set of house manuals content for all listings)
                                </span>
                              }
                              labelCol={{ className: "custom-checkbox-label" }}
                            >
                              <Checkbox
                                checked={useGlobalHouseManual}
                                onChange={handleGlobalHouseManual}
                                name="isSetGlobalHoseManual"
                                className="cus-checkbox-inline"
                              />
                            </Form.Item>
                          </Col>

                          {/* Editor - Controlled by checkbox */}
                          {!useGlobalHouseManual && (
                            <Col xs={24} className="mt-19">
                              <Form.Item
                                name="house_manual"
                                className="listing_field_name"
                              >
                                <div ref={editorHouseManualRef}>
                                <QuillEditor
                                  placeholder="Enter house manual"
                                  setValue={handlehouseManualValue}
                                  editorValue={previewHouseManual}
                                  handleInputChange={handleInputChange}
                                />
                                </div>
                              </Form.Item>
                            </Col>
                          )}
                        </Row>

                        {/* ── CHECKOUT INSTRUCTIONS ──────────────────── */}
                        <Row gutter={15} className=''>
                          <Col xs={24}>
                            <div className="arrival-header inner_preview_btn">
                              <Heading as="h3" className="mb-19 line_height_20 pr-10">
                                CHECKOUT INSTRUCTIONS
                              </Heading>
                            </div>
                          </Col>

                          {/* Checkbox */}
                          <Col xs={24} className=''>
                            <Form.Item
                              className="checkbox-title-inline listing-long-checkbox pb-19"
                              label={
                                <span>
                                  I have individual checkout instructions per listing (uncheck if you want
                                  to use one set of checkout instructions for all listings)
                                </span>
                              }
                              labelCol={{ className: "custom-checkbox-label" }}
                            >
                              <Checkbox
                                checked={useGlobalCheckoutInstructions}
                                onChange={handleGlobalCheckoutChange}
                                name="isSetGlobalCheckoutInstructions"
                              />
                            </Form.Item>
                          </Col>

                          {/* Editor - Conditional */}
                          {!useGlobalCheckoutInstructions && (
                            <Col xs={24} className="mt-19">
                              <Form.Item
                                name="checkout_instructions"
                                className="listing_field_name"
                              >
                                <div ref={editorCheckoutInstructionRef}>
                                <QuillEditor
                                  placeholder="Enter checkout instructions"
                                  setValue={handleCheckoutInstructionsValue}
                                  editorValue={previewCheckoutInstructions}
                                  handleInputChange={handleInputChange}
                                />
                                </div>
                              </Form.Item>
                            </Col>
                          )}
                        </Row>

                      </Cards>
                    </BasicFormWrapper>
                  </AddUser>
                </Form>
              </div>
            </div>
          </BasicFormWrapper>
        </AddUser>
      </Main>
      {/* </Cards> */}

      {/* ── SAVE / CANCEL ─────────────────────────────────── */}
      <div className="manage-listing-btn">
        <Button
          size='default'
          htmlType="submit"
          shape="circle"
          type="primary"
          key="save"
          className="w-100 edit-btn mr-10 ant-btn-primary"
          onClick={checkValidation}
        >
          {configuration ? 'Save' : 'Add'}
        </Button>
        <Button
          outlined
          shape="circle"
          type="primary"
          key="cancel"
          className="w-100 edit-btn ant-btn-primary"
          size="default"
          onClick={handleCancel}
        >
          Cancel
        </Button>
      </div>

      {/* ── DOOR CODE VARIABLE MODAL ──────────────────────── */}
      <Modal
        title="Select a Variable"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        className="select-variable-modal"
        maskClosable={false}
      >
        <ul>
          <li>
            <button
              type="button"
              className="link-btn"
              onClick={() => insertVariable('[DOOR_CODE]')}
            >
              DOOR_CODE
            </button>
          </li>
        </ul>
      </Modal>

      {/* ── HOUSE RULE GUIDELINES CMS MODAL ──────────────── */}
      <Modal
        type="primary"
        open={openthemeCms}
        onCancel={() => setOpenthemeCms(false)}
        footer={null}
        className="modal-md"
        key={2}
        destroyOnClose
        aria-hidden="false"
      >
        <div className="Idmodalbox earlyCheckinPopup">
          <div className="hostPayout">
            <div className="modal-content" dangerouslySetInnerHTML={{ __html: previewCmsContent }} />
          </div>
        </div>
      </Modal>

      {/* common modal */}
      <Modal
        type={state.modalType}
        visible={state.earlyCheckinPopupInfo}
        footer={null}
        onCancel={closeEarlyCheckInPopupInfo}
        className="modal-md"
        key={2}
        maskClosable={false}
        aria-hidden="false"
      >
        <div className="Idmodalbox earlyCheckinPopup">
          <div className="hostPayout">
            {earlyCheckInActivePopup === 27 ? (
              <div className="modal-content" dangerouslySetInnerHTML={{ __html: themeInfoModal }} />
            ) : earlyCheckInActivePopup === 31 ? (
              <div className="modal-content" dangerouslySetInnerHTML={{ __html: jotformActivePopup }} />
            ) : earlyCheckInActivePopup === 32 ? (
              <div className="modal-content" dangerouslySetInnerHTML={{ __html: welcomVideoModal }} />
            ) : (
              ''
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ConfigEdit;
